import { DownloadOutlined, InboxOutlined } from '@ant-design/icons';
import { Flex, Modal, UploadProps, notification } from 'antd';
import { UploadChangeParam, UploadFile } from 'antd/es/upload';
import Dragger from 'antd/es/upload/Dragger';
import { Dispatch, SetStateAction, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { AuthContext } from '../../../../../../context/auth-context';
import { API_URL } from '../../../../../../router/constants/constants';
import { ImportLecturersResponseDto } from '../../../../../../types/dto/user.dto';
import MainTitle from '../../../../../common/titles/main-title.component';

interface Props {
  isImportModalOpen: boolean;
  setIsImportModalOpen: Dispatch<SetStateAction<boolean>>;
  setLoading: Dispatch<SetStateAction<boolean>>;
}

const ImportLecturers = (props: Props) => {
  const { isImportModalOpen, setIsImportModalOpen, setLoading } = props;
  const token = window.localStorage.getItem('authToken');
  const { t } = useTranslation('user');
  const { user } = useContext(AuthContext);

  const [importResponse, setImportResponse] =
    useState<ImportLecturersResponseDto>();

  const handleChange: UploadProps['onChange'] = async (
    info: UploadChangeParam<UploadFile>
  ) => {
    const { status, response } = info.file;

    if (status === 'uploading') {
      setLoading(true);
      return;
    }

    if (status === 'done') {
      notification.success({
        key: user?.pin,
        message: t('new.import.success'),
      });

      setLoading(false);
    }
    if (status === 'error') {
      setImportResponse(response.data);
      notification.error({
        key: user?.pin,
        message: t('new.import.error'),
      });
      setLoading(false);
    }
    if (status === 'removed') {
      setImportResponse(undefined);
    }
  };

  const downloadXlsx = () => {
    const excelFilePath = 'assets/lecturers_import_table.xlsx';
    const link = document.createElement('a');
    link.href = excelFilePath;
    link.download = 'lecturers_import_table.xlsx';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Modal
      open={isImportModalOpen}
      onCancel={() => setIsImportModalOpen(false)}
      footer={false}
    >
      <MainTitle text={t('new.import.title')} />
      <Flex className='mb-1' gap={8}>
        <DownloadOutlined />
        <span className='download-link' onClick={downloadXlsx}>
          {t('new.import.download')}
        </span>
      </Flex>
      <Dragger
        accept='.xlsx, .xls'
        multiple={false}
        method='POST'
        action={`${API_URL}/api/admin/users/import-lecturers`}
        headers={{ Authorization: `Bearer ${token}` }}
        onChange={handleChange}
      >
        <p className='ant-upload-drag-icon'>
          <InboxOutlined />
        </p>
        <p className='ant-upload-text'>{t('new.import.instructions')}</p>
        <p className='ant-upload-hint'>{t('new.import.format')}</p>
      </Dragger>
      <Flex vertical className='mt-1 text-danger'>
        {importResponse ? (
          <span key={importResponse.index}>
            {t('new.import.message.title', {
              number: importResponse.index,
              reason: t(`new.import.message.${importResponse.reason}`),
            })}
          </span>
        ) : (
          <></>
        )}
      </Flex>
    </Modal>
  );
};

export default ImportLecturers;
